<template>
  <div class="basebuttongroup">
    <b-button
      class="basebuttongroup__button basebuttongroup__button-submit"
      :type="positiveType"
      @click.prevent="$emit('positive')"
      variant="primary"
      >{{ positiveText }}</b-button
    >
    <b-button
      class="basebuttongroup__button basebuttongroup__button-reset"
      :type="negativeType"
      @click.prevent="$emit('negative')"
      >{{ negativeText }}</b-button
    >
  </div>
</template>

<script>
export default {
  name: 'BaseButtonGroup',
  props: {
    positiveText: {
      type: String,
      default: '確認'
    },
    negativeText: {
      type: String,
      default: '取消'
    },
    positiveType: {
      type: String,
      default: 'submit'
    },
    negativeType: {
      type: String,
      default: 'reset'
    }
  }
};
</script>

<style lang="scss" scoped>
.basebuttongroup {
  text-align: right;
  &__button {
    background-color: $positive;
    border-color: $positive;
    padding: 8px 20px;
    &-submit {
      margin-right: 30px;
      &:hover {
        background-color: #3274c4;
        border-color: #3274c4;
        color: $white;
      }
    }
    &-reset {
      background-color: $white;
      color: $text-dark;
      border-color: $text-light;
      &:hover {
        background-color: $text-light;
        color: $black;
      }
    }
  }
}
</style>
